var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconFavorite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 1.75,
  d: "M19.776 22.63c-.814.689-1.687 1.427-2.619 2.235L16 25.85l-1.158-.986a277 277 0 0 0-2.62-2.237c-1.91-1.615-3.49-2.952-4.71-4.236-1.71-1.8-2.552-3.34-2.552-5.167 0-2.983 2.425-5.35 5.678-5.35 1.836 0 3.564.8 4.709 2.084l.653.733.653-.733c1.145-1.285 2.873-2.084 4.709-2.084 3.253 0 5.678 2.366 5.678 5.35 0 1.827-.842 3.367-2.552 5.167-1.22 1.285-2.801 2.622-4.712 4.238Z"
})));
export default SvgIconFavorite;